import { render, staticRenderFns } from "./HeaderStamp.vue?vue&type=template&id=5d8b61e3&"
import script from "./HeaderStamp.vue?vue&type=script&lang=js&"
export * from "./HeaderStamp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports